import axios from 'axios';
import { MANUAL_PAYMENT_METHOD } from '../constants/payment';

const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const endpoint = (path = '') => `${API_BASE}/api/manual-payment-orders/${path}`;

const getStoredToken = () => {
  try {
    return JSON.parse(localStorage.getItem('token'));
  } catch (e) {
    return null;
  }
};

const adminHeaders = () => {
  const token = getStoredToken();
  return {
    'Content-Type': 'application/json',
    'X-User-Id': token?.id || '',
    'X-User-Role-Id': token?.role?.id || '',
    'X-User-Role-Name': token?.role?.role_name || '',
  };
};

export const createManualPaymentOrder = (payload) => {
  const formData = new FormData();
  const append = (key, value) => {
    if (value !== undefined && value !== null) formData.append(key, value);
  };

  append('product_source', payload.productSource);
  append('product_id', payload.productId);
  append('product_name', payload.productName);
  append('product_image_url', payload.productImageUrl || '');
  append('product_url', payload.productUrl || window.location.href);
  append('unit_price', payload.unitPrice || 0);
  append('quantity', payload.quantity || 1);
  append('subtotal', payload.subtotal || 0);
  append('shipping_method', payload.shippingMethod || '');
  append('shipping_fee', payload.shippingFee || 0);
  append('shipping_eta', payload.shippingEta || '');
  append('shipping_option_snapshot', JSON.stringify(payload.shippingOptionSnapshot || {}));
  append('total_amount', payload.totalAmount || 0);
  append('currency', payload.currency || 'NGN');
  append('customer_name', payload.customerName);
  append('customer_phone', payload.customerPhone);
  append('customer_email', payload.customerEmail || '');
  append('customer_note', payload.customerNote || '');
  append('payment_method', MANUAL_PAYMENT_METHOD);
  append('whatsapp_message', payload.whatsappMessage || '');
  append('proof_of_payment', payload.proofFile);

  return axios.post(endpoint(), formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getManualPaymentOrders = (params = {}) =>
  axios.get(endpoint(), { params, headers: adminHeaders() });

export const getManualPaymentOrder = (id) =>
  axios.get(endpoint(`${id}/`), { headers: adminHeaders() });

export const updateManualPaymentOrder = (id, payload) =>
  axios.patch(endpoint(`${id}/`), payload, { headers: adminHeaders() });
